export default __webpack_public_path__ + "static/media/image-icon.6f882277.svg";